// components
import orContentBlock from './or-content-block.variants';
import { AtDivider } from '@/components/atoms/at-divider';

// types
import { EThemes } from '../../../lib/contentstack-sdk/types';
import { IOrcontentBlockProps } from './or-content-block.types';
import {
  EDividerColors,
  EDividerDirectionalVariants,
  EDividerVariants,
} from '@/components/atoms/at-divider/at-divider.types';

// utils + hooks
import { JSX } from 'react';
import classNames from 'classnames';

export const OrContentBlock = ({
  theme = EThemes.LIGHT,
  RenderLeftContent,
  topSpacing = 'md',
  bottomSpacing = 'md',
  topDivider = false,
  bottomDivider = false,
  children,
  ...rest
}: IOrcontentBlockProps): JSX.Element => {
  const classes = orContentBlock({ topSpacing, bottomSpacing });
  return (
    <section data-theme={theme} {...rest}>
      <div className={classNames('container w-full')}>
        {topDivider && (
          <AtDivider
            decorative
            color={EDividerColors.GREY}
            direction={EDividerDirectionalVariants.HORIZONTAL}
            intent={EDividerVariants.THIN}
          />
        )}
        <div
          className={classNames(
            'mx-auto grid grid-cols-1 md:grid-cols-6 lg:grid-cols-12',
            classes,
          )}
        >
          <div className="col-span-1 md:col-span-6 lg:col-span-5 2xl:px-72">
            {RenderLeftContent()}
          </div>
          <div className="md:gap-15 col-span-1 mt-60 grid grid-cols-1 gap-y-12 md:col-span-6 md:grid-cols-2 md:gap-4 lg:col-span-6 lg:col-start-7 lg:mt-0 lg:gap-12 2xl:px-9">
            {children}
          </div>
        </div>
        {bottomDivider && (
          <AtDivider
            decorative
            color={EDividerColors.GREY}
            direction={EDividerDirectionalVariants.HORIZONTAL}
            intent={EDividerVariants.THIN}
          />
        )}
      </div>
    </section>
  );
};
